export default "<p>skeleton-add works!</p>\r\n"